import { BASE_URL } from '../constants/api';
import Fetch from './fetch';

import { Emit } from '../components/socket';

import Store from '../stores/Store';

import { GlobalState } from '../states/global-state';

import type {
  ConfirmInformationReponseType,
  GetProfileResponseType,
  GetProfileResponseDataType,
  UploadResponseType,
} from 'src/types/types';
import { route } from 'preact-router';
import CacheService from '../utils/CacheService';
import {
  pause,
  showAlert,
  showAutoCloseAlert,
  showSpinner,
  hideSpinner,
} from '../utils';

export const confirmInformations =
  async function (): Promise<ConfirmInformationReponseType> {
    try {
      const store = new Store();
      const token = store.get('token');

      const url = `${BASE_URL}/api/userApi/pendingCustomer?token=${token}`;

      await showSpinner();

      const json = await Fetch<ConfirmInformationReponseType>(
        url,
        {
          method: 'POST',
          headers: {
            'x-token': store.get('x-token'),
            'x-csrf': store.get('x-csrf'),
            accept: 'application/json',
          },
          body: JSON.stringify({ token }),
        },
        0
      );

      await hideSpinner();
      if (json.code == 1) {
        return json as ConfirmInformationReponseType;
      }
      throw new Error(json.info);
    } catch (err) {
      showAlert({
        title: 'Error',
        text: err.message,
        icon: 'error',
      });
    }
  };

export const getProfile =
  async function (): Promise<GetProfileResponseDataType> {
    try {
      const store = new Store();

      const url = `${BASE_URL}/api/v1/profile`;

      await showSpinner();

      const json = await CacheService(
        '/profle',
        async () => {
          const json = await Fetch<GetProfileResponseType>(url, {
            method: 'GET',
            headers: {
              'x-token': store.get('x-token'),
              'x-csrf': store.get('x-csrf'),
              accept: 'application/json',
            },
          });

          return json;
        },
        { expiry: 5 }
      );

      await hideSpinner();
      if (json.status == 1) {
        return json.data as GetProfileResponseDataType;
      } else if (json.status == 2) {
        GlobalState.account.isLogIn.value = false;
        throw new Error('not login');
      }
      throw new Error(json.message);
    } catch (err) {
      if (err.message == 'not login') {
        return null;
      }
      return showAlert({
        title: 'Error',
        text: err.message,
        icon: 'error',
      });
    }
  };

export const changePassword = async function (data: {
  old_password: string;
  new_password: string;
  confirm_password: string;
}) {
  try {
    const store = new Store();
    const token = store.get('token');
    const email = store.get('email');

    const payload = {
      token,
      email,
      oldPassword: data.old_password,
      newPassword: data.new_password,
      confPassword: data.confirm_password,
    };

    const json: { code: number; info: string } = await new Promise(
      (res, rej) => {
        showSpinner();
        Emit('changeNewPassword', payload, response => {
          hideSpinner();
          res(response);
        });
      }
    );

    if (json.code == 1) {
      await showAutoCloseAlert({
        html: 'You will be logged out in <b></b> milliseconds.',
        title: 'Success',
        icon: 'success',
        timer: 1500,
        timerProgressBar: true,
      }).then(() => {
        route('/logout', true);
      });
    } else {
      showAlert({
        title: 'Error Change Password',
        text: json.info,
        icon: 'error',
      });
    }
  } catch (err) {
    showAlert({
      title: 'Error',
      text: err.message,
      icon: 'error',
    });
  }
};

export const changePicture = async function (
  data
): Promise<UploadResponseType> {
  try {
    const store = new Store();
    const token = store.get('token');
    const fd = new FormData();
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        fd.append(key, data[key]);
      }
    }

    const url = `${BASE_URL}/api/upload/attachFile/upload?token=${token}`;

    await showSpinner();
    const json = await Fetch<UploadResponseType>(url, {
      method: 'POST',
      headers: {
        'x-reg-token': store.get('x-reg-token'),
        'x-token': store.get('x-token'),
        'x-csrf': store.get('x-csrf'),
        accept: 'application/json',
      },
      body: fd,
    });

    await hideSpinner();

    return json;
  } catch (err) {
    await hideSpinner();
    await GlobalState.set.showModal(true, {
      message: err.message,
      showCancelBtn: false,
    });
  }
};
